// extracted by mini-css-extract-plugin
module.exports = {"root":"_2nvak0","image":"_2m13Nq","shine-lines":"ymx6eV"};